import { render, staticRenderFns } from "./PaymentChanges.vue?vue&type=template&id=2f632f3d&scoped=true"
import script from "./PaymentChanges.vue?vue&type=script&lang=js"
export * from "./PaymentChanges.vue?vue&type=script&lang=js"
import style0 from "./PaymentChanges.vue?vue&type=style&index=0&id=2f632f3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f632f3d",
  null
  
)

export default component.exports